import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

import {OfferLayoutBaseProps, OfferLayoutLoadingProps} from '.'
import {useCashbackPositioning} from './useCashbackPositioning'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${cssTheme.layout.spacing.s400};
`

const InfoWrapper = styled.div`
  &.--has-padding {
    padding-left: ${cssTheme.layout.spacing.s200};
  }
`

const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
`

export const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${cssTheme.layout.spacing.s600};
  padding-top: ${cssTheme.layout.spacing.s200};
`

export const PrimaryMultiColumnLayout: React.FC<
  OfferLayoutBaseProps | OfferLayoutLoadingProps
> = ({
  isLoading,
  priceComponent,
  cashbackComponent,
  providerLogoComponent,
  ctaComponent,
  roomNameComponent,
  roomLabelsComponent,
  tagComponent,
  dataId
}) => {
  const {showCashbackOnLeft, showCashbackOnRight} = useCashbackPositioning({
    cashbackComponent
  })

  if (isLoading)
    return (
      <SkeletonWrapper>
        <div>
          <SkeletonLoader width={139} />
          <SkeletonLoader width={90} />
        </div>
        <div>
          <SkeletonLoader width={56} align="right" />
          <SkeletonLoader width={86} align="right" />
        </div>
      </SkeletonWrapper>
    )

  return (
    <Wrapper data-id={dataId}>
      <div>
        <div>{tagComponent}</div>
        <InfoWrapper className={cx(Boolean(tagComponent) && '--has-padding')}>
          {providerLogoComponent}
          {roomNameComponent}
          {roomLabelsComponent}
          {showCashbackOnLeft}
        </InfoWrapper>
      </div>
      <RightWrapper>
        {priceComponent}
        {showCashbackOnRight}
        {ctaComponent}
      </RightWrapper>
    </Wrapper>
  )
}
